import type React from 'react'
import styled from 'styled-components'

import { InformationListAccordion } from '@components/ui'

import { HowToCalculateTitleMessage } from '@messages'

const StyledInformationListAccordion = styled(InformationListAccordion)`
  /* it must have the margin here to avoid everything having a wrapper div */
  margin-top: 24px;
`

interface TaxationLimitInformationProps {
  children: NonNullable<React.ReactNode> | React.ReactNode[]
}

/**
 * Simple listing component for taxation detail information
 *
 * @param {TaxationLimitInformationProps} { children } elements to be wrapped in a <li> tag
 */
export function TaxationLimitInformation({ children }: TaxationLimitInformationProps) {
  return (
    <StyledInformationListAccordion title={HowToCalculateTitleMessage} titleTag="h2" visibleOnRender>
      {children}
    </StyledInformationListAccordion>
  )
}
